export default __webpack_public_path__ + "static/media/brand-image-09.7dc63be0.jpg";